import React, { Fragment, useEffect } from 'react';
import { Card, CardText, Cell, Grid } from 'react-md';
import { FSQ2 } from '../../components/';
import '../style.css';
import Axios from 'axios';
const env = process.env;

export default (props) => {
  const checkToken = async () => {
    Axios.defaults.headers.common['Authorization'] = localStorage.token;
    const response = await Axios.get(env['REACT_APP_AUTH'] + '/token');
    if (!response.data.valid) {
      localStorage.clear();
      props.setLogged(false);
      setTimeout(() => {}, 1000);
    }
    props.reload(response.data.version);
    return response.data.valid;
  };

  useEffect(() => {
    async function tttt() {
      await checkToken();
    }
    tttt();
  }, []);
  return (
    <Fragment>
      <Grid>
        <Cell size={3} phoneSize={12} tabletSize={12}>
          <span style={{ fontSize: 35, color: 'gray' }}>Status Query</span>
        </Cell>
      </Grid>
      <Grid>
        <Cell size={12} style={{ marginBottom: '30px' }}>
          <Card raise tableCard>
            <CardText>
              <FSQ2 {...props} />
            </CardText>
          </Card>
        </Cell>
      </Grid>
    </Fragment>
  );
};
